// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@material-ui/core";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Route_Paths$DvmAdminFrontendFr from "../../../../route/Route_Paths.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../theme/Theme_Colors.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../common/App_Typography.bs.js";
import * as Context_Router$DvmAdminFrontendFr from "../../../../context/router/Context_Router.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../common/types/App_Types_Result.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../context/user/User_Types_Utils.bs.js";
import * as Order_Detail_Utils$DvmAdminFrontendFr from "../Order_Detail_Utils.bs.js";
import * as Bonuses_Search_Form$DvmAdminFrontendFr from "../../../bonusesList/Bonuses_Search_Form.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Bonus_Box$DvmAdminFrontendFr from "./Order_Detail_Bonus_Box.bs.js";
import * as Order_Detail_Budget_Box$DvmAdminFrontendFr from "./Order_Detail_Budget_Box.bs.js";
import * as Order_Detail_Types_Order_Type$DvmAdminFrontendFr from "../Order_Detail_Types_Order_Type.bs.js";
import * as Order_Detail_Bonus_Derogate_Fleet$DvmAdminFrontendFr from "./derogate/view/Order_Detail_Bonus_Derogate_Fleet.bs.js";
import * as Order_Detail_Bonus_Derogate_Create$DvmAdminFrontendFr from "./derogate/create/Order_Detail_Bonus_Derogate_Create.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Api$DvmAdminFrontendFr from "./dealerRequest/Order_Detail_Bonus_DealerRequest_Api.bs.js";
import * as Order_Detail_Bonus_Derogate_NonFleet$DvmAdminFrontendFr from "./derogate/view/Order_Detail_Bonus_Derogate_NonFleet.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create$DvmAdminFrontendFr from "./dealerRequest/create/Order_Detail_Bonus_DealerRequest_Create.bs.js";
import * as Order_Detail_Bonus_Derogate_Create_Types$DvmAdminFrontendFr from "./derogate/create/Order_Detail_Bonus_Derogate_Create_Types.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Documents_Api$DvmAdminFrontendFr from "./dealerRequest/viewDocuments/Order_Detail_Bonus_DealerRequest_Documents_Api.bs.js";

function Order_Detail_Bonuses(Props) {
  var order = Props.order;
  var orderId = Props.orderId;
  var reloadPage = Props.reloadPage;
  var actualOrderType = Props.actualOrderType;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDocumentsResult = match$2[1];
  var documentsResult = match$2[0];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDealerRequests = match$3[1];
  var dealerRequests = match$3[0];
  var match$4 = Curry._1(Context_Router$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var dispatch = match$4[1];
  var intl = ReactIntl.useIntl();
  var match$5 = React.useState(function () {
        return null;
      });
  var setModal = match$5[1];
  React.useEffect((function () {
          Order_Detail_Bonus_DealerRequest_Api$DvmAdminFrontendFr.fetchDealerRequests(userManager, setDealerRequests, selectedRole, orderId);
        }), []);
  React.useEffect((function () {
          if (Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16) === /* SO */0) {
            
          } else {
            App_Types_Result$DvmAdminFrontendFr.mapWithDefault(dealerRequests, undefined, (function (x) {
                    if (Belt_List.length(x) > 0) {
                      return Order_Detail_Bonus_DealerRequest_Documents_Api$DvmAdminFrontendFr.fetchDocuments(userManager, setDocumentsResult, selectedRole, orderId);
                    }
                    
                  }));
          }
        }), [dealerRequests]);
  var openModalDerogate = function (action, editedDero, usedAction, param) {
    Belt_Option.mapWithDefault(order.header.orderOrderType, undefined, (function (orderType) {
            Curry._1(setModal, (function (param) {
                    return React.createElement(Order_Detail_Bonus_Derogate_Create$DvmAdminFrontendFr.make, {
                                order: order,
                                orderId: orderId,
                                action: action,
                                onClose: (function (param) {
                                    Curry._1(setModal, (function (param) {
                                            return null;
                                          }));
                                  }),
                                onOk: (function (param) {
                                    Curry._1(setModal, (function (param) {
                                            return null;
                                          }));
                                    Curry._1(reloadPage, undefined);
                                  }),
                                orderType: orderType,
                                editedDero: editedDero,
                                usedAction: usedAction
                              });
                  }));
          }));
  };
  var getFleetBox = function (bonus, actionType) {
    var color = actionType === "perf" ? "#ffbc69" : (
        actionType === "repr" ? "green" : (
            actionType === "stoc" ? "#622717" : "red"
          )
      );
    return React.createElement(React.Fragment, undefined, React.createElement(Order_Detail_Bonus_Box$DvmAdminFrontendFr.make, {
                    bonus: bonus,
                    color: color,
                    openModal: (function ($$event) {
                        openModalDerogate({
                              actionType: actionType,
                              actionId: Belt_Option.getWithDefault(bonus.actionId, ""),
                              actionIdLabel: bonus.actionLabel,
                              budget: Belt_Option.flatMap(order.budgetBonus, (function (x) {
                                      return x.orderBudgetType;
                                    })),
                              actionBonusValue: bonus.actionBonusValue,
                              actionBonusPercentage: bonus.actionBonusPercentage,
                              actionCalcMethod: bonus.actionCalcMethod,
                              resultBonusPaid: bonus.resultBonusPaid
                            }, undefined, undefined, undefined);
                      }),
                    archived: Belt_Option.getWithDefault(order.body.resultOrderArchived, true),
                    order: order,
                    documentsResult: documentsResult,
                    dealerRequests: dealerRequests,
                    orderId: orderId,
                    reloadPage: reloadPage,
                    kind: "fleet",
                    key: Belt_Option.getWithDefault(bonus.actionId, "")
                  }), Belt_List.toArray(Belt_List.map(Belt_Option.getWithDefault(bonus.deros, /* [] */0), (function (dero) {
                          return React.createElement(Order_Detail_Bonus_Derogate_Fleet$DvmAdminFrontendFr.make, {
                                      dero: dero,
                                      color: color,
                                      order: order,
                                      orderId: orderId,
                                      reloadPage: reloadPage,
                                      openEditModal: (function ($$event) {
                                          openModalDerogate(undefined, dero, actionType, undefined);
                                        }),
                                      key: dero.derogationId
                                    });
                        }))));
  };
  return React.createElement(Core.Box, {
              children: null,
              marginTop: 3
            }, React.createElement(Core.Grid, {
                  children: null,
                  container: true,
                  direction: "column"
                }, React.createElement(Core.Grid, {
                      children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                            color: "primary",
                            style: {
                              fontWeight: "600"
                            },
                            children: "" + intl.formatMessage(Messages_Orders_Detail$DvmAdminFrontendFr.orderBonuses) + " " + Belt_Option.getWithDefault(order.header.orderCustomerOrderNumber, "-") + "",
                            variant: "h3"
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                            color: "textSecondary",
                            children: React.createElement(Core.Link, {
                                  children: intl.formatMessage(Messages_Orders_Detail$DvmAdminFrontendFr.orderBonusesSubtitle),
                                  style: {
                                    cursor: "pointer"
                                  },
                                  onClick: (function ($$event) {
                                      var newrecord = Caml_obj.obj_dup(Bonuses_Search_Form$DvmAdminFrontendFr.initialState);
                                      Curry._1(dispatch, {
                                            TAG: /* StoreBonusesFilter */15,
                                            _0: (newrecord.orderType = {
                                                hd: Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(Belt_Option.getWithDefault(Belt_Option.mapWithDefault(actualOrderType, order.header.orderOrderType, (function (x) {
                                                                return x;
                                                              })), /* NOTSET */16)),
                                                tl: /* [] */0
                                              }, newrecord.orderId = Belt_Option.getWithDefault(order.header.orderCustomerOrderNumber, ""), newrecord.dealerId = {
                                                hd: Belt_Option.getWithDefault(order.header.orderDealerId, ""),
                                                tl: /* [] */0
                                              }, newrecord)
                                          });
                                      Curry._1(dispatch, {
                                            TAG: /* StoreBonusesModalFilter */16,
                                            _0: undefined
                                          });
                                      Curry._1(dispatch, {
                                            TAG: /* StoreBonusesModalAdditionalFilter */17,
                                            _0: undefined
                                          });
                                      Curry._1(dispatch, {
                                            TAG: /* StoreBonusesModalAdditionalSecondFilter */18,
                                            _0: undefined
                                          });
                                      Curry._1(dispatch, {
                                            TAG: /* StoreBonusesModalVOFilter */19,
                                            _0: undefined
                                          });
                                      RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rView + Route_Paths$DvmAdminFrontendFr.rBonuses);
                                    })
                                }),
                            variant: "subtitle"
                          }),
                      item: true
                    }), User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) && !Belt_Option.getWithDefault(order.body.resultOrderArchived, false) ? React.createElement(Core.Grid, {
                        children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                              color: "textSecondary",
                              children: React.createElement(Core.Link, {
                                    children: intl.formatMessage(Messages_Orders_Detail$DvmAdminFrontendFr.addUnexistActionButton),
                                    style: {
                                      cursor: "pointer"
                                    },
                                    onClick: (function ($$event) {
                                        openModalDerogate(undefined, undefined, undefined, undefined);
                                      })
                                  }),
                              variant: "subtitle"
                            }),
                        item: true
                      }) : null, !Belt_Option.getWithDefault(order.body.resultOrderArchived, true) && (Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16) === /* SO */0 || Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16) === /* CL */1) && Order_Detail_Utils$DvmAdminFrontendFr.rolesCanDealerRequest(selectedRole) ? React.createElement(Core.Grid, {
                        children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                              color: "textSecondary",
                              children: React.createElement(Core.Link, {
                                    children: intl.formatMessage(Messages_Orders_Detail$DvmAdminFrontendFr.addDealerRequest),
                                    style: {
                                      cursor: "pointer"
                                    },
                                    onClick: (function ($$event) {
                                        Belt_Option.mapWithDefault(order.header.orderOrderType, undefined, (function (orderType) {
                                                Curry._1(setModal, (function (param) {
                                                        return React.createElement(Order_Detail_Bonus_DealerRequest_Create$DvmAdminFrontendFr.make, {
                                                                    order: order,
                                                                    orderId: orderId,
                                                                    action: undefined,
                                                                    onClose: (function (param) {
                                                                        Curry._1(setModal, (function (param) {
                                                                                return null;
                                                                              }));
                                                                      }),
                                                                    onOk: (function (param) {
                                                                        Curry._1(setModal, (function (param) {
                                                                                return null;
                                                                              }));
                                                                        Curry._1(reloadPage, undefined);
                                                                      }),
                                                                    orderType: orderType,
                                                                    savedDocuments: /* [] */0,
                                                                    reloadPage: reloadPage,
                                                                    existingRequests: dealerRequests
                                                                  });
                                                      }));
                                              }));
                                      })
                                  }),
                              variant: "subtitle"
                            }),
                        item: true
                      }) : null, Belt_Option.mapWithDefault(order.header.orderOrderType, null, (function (orderType) {
                        if (orderType > 15 || orderType < 1) {
                          if (orderType >= 16) {
                            return null;
                          }
                          
                        } else if (orderType !== 11) {
                          return Belt_List.toArray(Belt_List.map(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (action) {
                                            return React.createElement(React.Fragment, undefined, React.createElement(Order_Detail_Bonus_Box$DvmAdminFrontendFr.make, {
                                                            bonus: action,
                                                            color: Theme_Colors$DvmAdminFrontendFr.primaryBrown,
                                                            openModal: (function ($$event) {
                                                                openModalDerogate({
                                                                      actionType: "nonfleet",
                                                                      actionId: Belt_Option.getWithDefault(action.actionId, ""),
                                                                      actionIdLabel: action.actionLabel,
                                                                      budget: undefined,
                                                                      actionBonusValue: action.actionBonusValue,
                                                                      actionBonusPercentage: action.actionBonusPercentage,
                                                                      actionCalcMethod: action.actionCalcMethod,
                                                                      resultBonusPaid: action.resultBonusPaid
                                                                    }, undefined, undefined, undefined);
                                                              }),
                                                            archived: Belt_Option.getWithDefault(order.body.resultOrderArchived, true),
                                                            order: order,
                                                            documentsResult: documentsResult,
                                                            dealerRequests: dealerRequests,
                                                            orderId: orderId,
                                                            reloadPage: reloadPage,
                                                            kind: "nonfleet",
                                                            key: Belt_Option.getWithDefault(action.actionId, "")
                                                          }), Belt_List.toArray(Belt_List.map(Belt_Option.getWithDefault(action.deros, /* [] */0), (function (dero) {
                                                                  return React.createElement(Order_Detail_Bonus_Derogate_NonFleet$DvmAdminFrontendFr.make, {
                                                                              dero: dero,
                                                                              color: "FF5544",
                                                                              order: order,
                                                                              orderId: orderId,
                                                                              reloadPage: reloadPage,
                                                                              openEditModal: (function ($$event) {
                                                                                  openModalDerogate(undefined, dero, "nonfleet", undefined);
                                                                                }),
                                                                              key: dero.derogationId
                                                                            });
                                                                }))));
                                          })));
                        }
                        return React.createElement(React.Fragment, undefined, React.createElement(Order_Detail_Budget_Box$DvmAdminFrontendFr.make, {
                                        color: "blue",
                                        openModal: (function ($$event) {
                                            Belt_Option.mapWithDefault(order.budgetBonus, undefined, (function (budget) {
                                                    openModalDerogate({
                                                          actionType: "budget",
                                                          actionId: "",
                                                          actionIdLabel: undefined,
                                                          budget: budget.orderBudgetType,
                                                          actionBonusValue: undefined,
                                                          actionBonusPercentage: undefined,
                                                          actionCalcMethod: undefined,
                                                          resultBonusPaid: undefined
                                                        }, undefined, undefined, undefined);
                                                  }));
                                          }),
                                        order: order,
                                        orderId: orderId,
                                        reloadPage: reloadPage,
                                        key: orderId
                                      }), Belt_List.toArray(Belt_List.map(Belt_Option.getWithDefault(Belt_Option.flatMap(order.budgetBonus, (function (budget) {
                                                      return budget.deros;
                                                    })), /* [] */0), (function (dero) {
                                              return React.createElement(Order_Detail_Bonus_Derogate_Fleet$DvmAdminFrontendFr.make, {
                                                          dero: dero,
                                                          color: "blue",
                                                          order: order,
                                                          orderId: orderId,
                                                          reloadPage: reloadPage,
                                                          openEditModal: (function ($$event) {
                                                              openModalDerogate(undefined, dero, "budget", undefined);
                                                            }),
                                                          key: dero.derogationId
                                                        });
                                            }))), Belt_List.toArray(Belt_List.map(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                                                  return Belt_Option.getWithDefault(x.actionType, "") === "STOC";
                                                })), (function (stoc) {
                                              return getFleetBox(stoc, "stoc");
                                            }))), Belt_List.toArray(Belt_List.map(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                                                  return Belt_Option.getWithDefault(x.actionType, "") === "PERF";
                                                })), (function (perf) {
                                              return getFleetBox(perf, "perf");
                                            }))), Belt_List.toArray(Belt_List.map(Belt_List.keep(Belt_Option.getWithDefault(order.bonuses, /* [] */0), (function (x) {
                                                  return Belt_Option.getWithDefault(x.actionType, "") === "REPR";
                                                })), (function (repr) {
                                              return getFleetBox(repr, "repr");
                                            }))));
                      })), Belt_List.toArray(Belt_List.map(Belt_Option.getWithDefault(order.orderDeros, /* [] */0), (function (dero) {
                            var match = Belt_Option.getWithDefault(order.header.orderOrderType, /* NOTSET */16);
                            if (match !== 11 && match !== 0) {
                              return React.createElement(Order_Detail_Bonus_Derogate_NonFleet$DvmAdminFrontendFr.make, {
                                          dero: dero,
                                          color: "black",
                                          order: order,
                                          orderId: orderId,
                                          reloadPage: reloadPage,
                                          openEditModal: (function ($$event) {
                                              openModalDerogate(undefined, dero, "nonfleet", undefined);
                                            }),
                                          key: dero.derogationId
                                        });
                            }
                            return React.createElement(Order_Detail_Bonus_Derogate_Fleet$DvmAdminFrontendFr.make, {
                                        dero: dero,
                                        color: "black",
                                        order: order,
                                        orderId: orderId,
                                        reloadPage: reloadPage,
                                        openEditModal: (function ($$event) {
                                            openModalDerogate(undefined, dero, Order_Detail_Bonus_Derogate_Create_Types$DvmAdminFrontendFr.usedActionFromStr(dero.derogatedActionType), undefined);
                                          }),
                                        key: dero.derogationId
                                      });
                          })))), match$5[0]);
}

var make = Order_Detail_Bonuses;

export {
  make ,
}
/* react Not a pure module */
